import { callGetUiFlags, callUpdateUiFlags } from "api/MuyeonApi";

/**
 * 튜토리얼/안내 확인 여부 관리 — 최초 1회만 노출.
 *  1차 localStorage(기기, 동기 판독) + 2차 서버 uiFlags(계정) 이중 저장:
 *   - 재설치/기기 변경 → 로그인 후 서버 플래그를 병합해 재노출 방지
 *   - localStorage 불가 환경(프라이빗 모드 등) → 메모리 폴백으로 세션당 1회는 노출
 */
const PREFIX = "muyeon.tut.";
const mem = {}; // localStorage 실패 시 세션 한정 폴백

export const TUTORIAL_KEYS = {
  lessonTab: "lessonTab.v1", // 강사 탭 첫 방문 튜토리얼
  lessonTabGuide: "lessonTabGuide.v1", // 강사 탭 상단 안내 배너(X 클릭 시 영구 미노출)
  myTypeTab: "myTypeTab.v1", // 하단 MY(내 유형) 탭 '길게 눌러 보세요' 안내 — 홈 첫 진입 1회
  seekProfilePreview: "seekProfilePreview.v1", // 구직 프로필 i(미리보기) 아이콘 안내 — 멤버십 적용 화면 유도
};

export function hasSeenTutorial(key) {
  try { return localStorage.getItem(PREFIX + key) === "1"; } catch (e) { return mem[key] === true; }
}

export function markTutorialSeen(key) {
  try { localStorage.setItem(PREFIX + key, "1"); } catch (e) { mem[key] = true; }
  // 계정 기준 동기화 — 실패해도 로컬로 동작(비로그인/목업 포함)
  callUpdateUiFlags({ [key]: true }).catch(() => {});
}

// 서버 플래그 → 로컬 병합(세션당 1회). 화면은 이 Promise 후 hasSeenTutorial 을 재평가하면 된다.
let serverSync = null;
export function syncTutorialFlagsFromServer() {
  if (!serverSync) {
    serverSync = callGetUiFlags()
      .then((r) => {
        const flags = r?.data?.flags || {};
        Object.entries(flags).forEach(([k, v]) => {
          if (v === true) {
            try { localStorage.setItem(PREFIX + k, "1"); } catch (e) { mem[k] = true; }
          }
        });
        return flags;
      })
      .catch(() => ({}));
  }
  return serverSync;
}
